<template>
  <div class="fund-wallet-modal">
    <div class="connection-list-wrapper fund">
      <div
        data-w-id="9749f7e2-5d03-6905-2e47-60e928926444"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52 connection">
        <h1 class="modal-heading connection" v-if="currencyModal">
          Select currency
        </h1>
        <h1 class="modal-heading connection" v-else>Fund Wallet</h1>
      </div>
      <div v-if="currencyModal" class="connections fund">
        <div
          @click="activateOption1"
          :class="
            currency1 ? 'payment-style-box payment-active' : 'payment-style-box'
          "
        >
          <div>
            <img
              src="@/assets/timeslot-images/nigeria.png"
              width="32"
              height="32"
            />
          </div>
          <div>
            <div class="payment-style">
              NGN<span class="payment-style-amount"></span>
            </div>
            <!--              <div class="payment-style-amount">-->
            <!--                Includes access to classes and materials for one student only-->
            <!--              </div>-->
          </div>
          <div>
            <img
              src="@/assets/timeslot-images/payment-style-circle.svg"
              v-if="!currency1"
            />
            <img
              src="@/assets/timeslot-images/payment-style-checkbox.svg"
              v-else
            />
          </div>
        </div>
        <div
          :class="
            currency2 ? 'payment-style-box payment-active' : 'payment-style-box'
          "
          @click="activateOption2"
        >
          <div>
            <img
              src="@/assets/timeslot-images/united-states.png"
              width="32"
              height="32"
            />
          </div>
          <div>
            <div class="payment-style">
              USD<span class="payment-style-amount"></span>
            </div>
            <!--              <div class="payment-style-amount">-->
            <!--                Includes access to classes and materials for one student only till-->
            <!--                payment is completed-->
            <!--              </div>-->
          </div>
          <div>
            <img
              src="@/assets/timeslot-images/payment-style-circle.svg"
              v-if="!currency2"
            />
            <img
              src="@/assets/timeslot-images/payment-style-checkbox.svg"
              v-else
            />
          </div>
        </div>
        <!--          <div class="payment-style-container">-->
        <button @click="goToPaymentAmountModal" class="button-15 button">
          Continue
        </button>
        <!--          </div>-->
      </div>
      <div v-if="!payment_status && !currencyModal" class="connections fund">
        <input
          type="text"
          class="text-field-3 w-input"
          maxlength="256"
          name="field"
          data-name="Field"
          placeholder="$"
          id="field"
          required=""
          v-model="payModel.amount"
        />
        <div class="button-15 red w-button" v-if="loading">
          <div class="small-loader" :style="{ textAlign: 'center' }">
            <div class>
              <div class="jt">
                <svg height="100%" viewBox="0 0 32 32" width="100%">
                  <circle
                    cx="16"
                    cy="16"
                    fill="none"
                    r="14"
                    stroke-width="4"
                    style="stroke: #FFFFFF; opacity: 0.2;"
                  />
                  <circle
                    cx="16"
                    cy="16"
                    fill="none"
                    r="14"
                    stroke-width="4"
                    style="stroke: #FFFFFF; stroke-dasharray: 80; stroke-dashoffset: 60;"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            data-w-id="1b3d4daf-0a70-8b14-8027-e7299cdd755a"
            class="button-15 w-button"
            v-if="currency1"
            @click="proceedToFlutterwave"
          >
            Proceed
          </div>
          <div
            data-w-id="1b3d4daf-0a70-8b14-8027-e7299cdd755a"
            class="button-15 w-button"
            @click="proceed"
            v-if="currency2"
          >
            Proceed
          </div>
        </div>
      </div>
      <div v-if="payment_status && !currencyModal" class="margin-payment">
        <!--        <p>payment</p>-->
        <stripe-element-payment
          ref="paymentRef"
          :pk="pk"
          :elements-options="elementsOptions"
          :confirm-params="confirmParams"
        />
        <div class="button-15 w-button" v-if="payLoading">
          <div class="small-loader" :style="{ textAlign: 'center' }">
            <div class>
              <div class="jt">
                <svg height="100%" viewBox="0 0 32 32" width="100%">
                  <circle
                    cx="16"
                    cy="16"
                    fill="none"
                    r="14"
                    stroke-width="4"
                    style="stroke: #FFFFFF; opacity: 0.2;"
                  />
                  <circle
                    cx="16"
                    cy="16"
                    fill="none"
                    r="14"
                    stroke-width="4"
                    style="stroke: #FFFFFF; stroke-dasharray: 80; stroke-dashoffset: 60;"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          data-w-id="1b3d4daf-0a70-8b14-8027-e7299cdd755a"
          class="button-15 w-button"
          @click="pay"
          v-else
        >
          Pay
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import WalletRequest from "@/model/requests/WalletRequest";
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
let clientSecret;

import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
export default {
  name: "FundWalletModal",
  components: { StripeElementPayment },
  props: {
    cancel: Function
  },
  data() {
    return {
      payModel: WalletRequest.createPaymentIntent,
      payLoading: false,
      pk:
        "pk_live_51Lj0x3JcyYCn3q9Q1lKPTJ9T73FO401mhf8a5hXbssP3ViLhIXaMr1NLbKJjuSYmYKCuw9hbYgA2THAtkjFupYie00QhzNXslJ",
      elementsOptions: {
        // clientSecret: "pi_3LmOxEJcyYCn3q9Q0V9lNjd7_secret_AF8m1i3fcQdkJxJTVPwpGLxbd",
        clientSecret: clientSecret,
        appearance: {}
      },
      confirmParams: {
        return_url: `https://app.timeslate.com/payment-successful`
      },
      currency1: false,
      currency2: false,
      currencyModal: true,
      flutterwaveFundingModel: WalletRequest.flutterwaveFunding,
      flutterwaveVerifyModel: WalletRequest.flutterwaveVerify
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      payment_status: state => state.wallet.paymentStatus,
      paymentIntent: state => state.wallet.paymentIntent,
      loading: state => state.wallet.loading,
      flutterwaveURL: state => state.wallet.flutterwaveURL
    }),
    CLIENT_SECRET() {
      return this.elementsOptions.clientSecret;
    },
    ...mapState(["loader"]),
    host() {
      return `${window.location.protocol}//${window.location.hostname}`;
    }
  },
  methods: {
    async proceed() {
      await StoreUtils.dispatch("wallet/createPaymentIntent", this.payModel);
      this.elementsOptions.clientSecret = this.paymentIntent.client_secret;
    },
    pay() {
      this.$refs.paymentRef.submit();
      this.payLoading = true;
      // console.log("clicked");
    },
    proceedToFlutterwave() {
      this.flutterwaveFundingModel.amount = this.payModel.amount;
      this.flutterwaveFundingModel.currency = "NGN";
      this.flutterwaveFundingModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch(
        "wallet/flutterwaveFunding",
        this.flutterwaveFundingModel
      );
    },
    goToPaymentAmountModal() {
      this.currencyModal = false;
    },
    activateOption1() {
      this.currency1 = true;
      this.currency2 = false;
    },
    activateOption2() {
      this.currency1 = false;
      this.currency2 = true;
    }
  },
  watch: {
    "paymentIntent.client_secret"(newValue, oldValue) {
      if (newValue) {
        this.elementsOptions.clientSecret = newValue;
        // console.log(`the new value: ${newValue}:  the old value: ${oldValue}`);
        clientSecret = newValue;
      } else {
        this.elementsOptions.clientSecret = "";
        clientSecret = oldValue;
      }
    }
  },
  mounted() {
    StoreUtils.commit("wallet/updatePaymentStatus", false);
    this.elementsOptions.clientSecret = this.paymentIntent.client_secret;
  }
};
</script>

<style scoped>
.margin-payment {
  margin-top: 20px;
}
/*.red {*/
/*  background-color: #fb2c56;*/
/*}*/
.small-loader {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.small-loader .jt {
  height: 30px;
  width: 30px;
  display: inline-block;
}
.small-loader svg {
  transform: translate(50%, 50%);
  animation: spin 0.5s infinite linear;
}
.payment-modal-title {
  font-family: GTEestiProDisplay-Regular, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.01em;
  color: #1e2757;
  margin-bottom: 10px;
}
.payment-modal-sub {
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #7d90b8;
  margin-bottom: 45px;
  font-family: "Galano grotesque-Medium", sans-serif;
}
.payment-style {
  font-family: "Galano grotesque-Medium", sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #1e2757;
}
.payment-style-amount {
  color: #0098da;
}
.payment-style-box {
  display: flex;
  justify-content: space-between;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  gap: 10px;
}
.payment-style-box:hover {
  background-color: rgba(230, 245, 251, 0.5);
  border: 1px solid #0098da;
}
.payment-active {
  border: 1px solid #0098da;
  background-color: #e6f5fb;
}
._3 {
  position: relative;
}
.limited-time-badge {
  background-color: #ecfdf3;
  color: #027a48;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 2px 8px;
  font-family: GTEestiProDisplay-Regular, sans-serif;
  border-radius: 16px;
  border: none;
  mix-blend-mode: multiply;
  width: 105px;
  height: 22px;
  position: absolute;
  z-index: 999;
  right: 45px;
  top: -15px;
  outline: none;
}

.payment-style-container {
  display: flex;
  justify-content: center;
  margin-top: 45px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
